// extracted by mini-css-extract-plugin
module.exports = {"vUiHue":"#ddd","vWhite":"#fff","wrapper":"AddSection__wrapper___xi1aE"};